<template>
  <div>

    <Head style="backgroundColor: #fff;"></Head>
    <navigationbar cid="1"></navigationbar>
    <div class="firstdiv"></div>
    <div class="content flex flex-direction align-center">

      <div class="flex flex-direction width  center hidden"
           style="height: auto; margin-top: 0.4rem ">
        <p style="height:.86rem;line-height:.86rem"
           class=" font-color-ff bg-color-23 font-size-24 text-center">活动介绍</p>
        <div class="flex justify-center align-center"
             style="width:100%">
          <img style="width:13.19rem;height:3.53rem;margin-top:0.45rem"
               :src="dataMode.ImageUrl"
               alt="">
        </div>

        <div style="padding:.4rem .73rem 0  .73rem"
             class=" font-size-24 flex">
          <p class=" font-color-11A">活动时间：</p>
          <p class="  font-color-73">{{dataMode.StartTime}} 至 {{dataMode.EndTime}}</p>
        </div>
        <div style="padding:.3rem .73rem 0  .73rem"
             class=" font-size-24 flex">
          <p class=" font-color-11A">主 办 方：</p>
          <p class="  font-color-73">{{dataMode.Sponsor}}</p>
        </div>
        <!-- <div style="padding:.3rem .73rem 0  .73rem"
             class=" font-size-24 flex">
          <p class=" font-color-11A">活动类型：</p>
          <p class="  font-color-73">{{dataMode.ActType}}</p>
        </div> -->
        <div v-if="dataMode.Status == 1"
             style="padding:.3rem .73rem 0  .73rem"
             class=" font-size-24 flex">
          <p class=" font-color-11A"
             style=" white-space: nowrap;">活动介绍：</p>
          <div class="flex flex-direction flex-sub"
               style="padding-bottom:.45rem">
            <div class=' font-color-73 '
                 v-html="dataMode.Details"></div>

          </div>
        </div>
        <div v-else-if="dataMode.Status == 2"
             style="height:4rem;width:100%;color:#959595;font-size:0.42rem"
             class=" flex align-center justify-center">

          活动已经结束！
        </div>

      </div>

      <!-- <div class="seconddiv"></div> -->
    </div>
  </div>
</template>

<script>
import common from "@/utils/common.js";
export default {
  data () {
    return {
      dataMode: {},
    };
  },

  created () {

    var id = this.$route.params.id || 0
    if (id == 0) {
      this.$router.replace({
        name: 'splash',
      })
    } else {
      this.getActivityDes()
    }
  },
  mounted () {

  },

  methods: {

    getActivityDes () {


      this.getRequest('api/v1/Activity/Details', { Id: this.$route.params.id }).then(data => {
        console.log(data);

        if (data.IsSuccess) {

          data.Data.EndTime = common.formatDateYMD(data.Data.EndTime).allDate
          data.Data.StartTime = common.formatDateYMD(data.Data.StartTime).allDate
          this.dataMode = data.Data;
        }
      })
    },



  },
};
</script>

<style scoped>
.firstdiv {
  background: url("../../assets/video/icon-video-bg.jpg");
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  /* background-size: 100% auto; */
  position: fixed;
  /* height: 5.05rem; */
  top: 0;
  left: 0;
  z-index: -1;
  background-color: #cbfeee;
}

.content {
  padding-bottom: 0.56rem;
}

.seconddiv {
  background-size: 100% auto;
  margin-top: -3.5rem;
  background: url("../../assets/video/icon-video-bottombg.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: bottom;
  width: 100%;
  height: 5.97rem;
}

.center {
  margin-top: -4.71rem;
  min-height: 10.73rem;
  background: #ffffff;
  box-shadow: 0 0 0.22rem 0.05rem rgba(155, 199, 219, 0.35);
  border-radius: 0.16rem;
  z-index: 3;
}
.erweima {
  height: 5.91rem;
  margin-top: 0.58rem;
  background: #edf5ff;
}
.erweima .size {
  width: 2.13rem;
  height: 0.78rem;
  font-size: 0.3rem;
  font-weight: bold;
  color: #1e1e1e;
  line-height: 0.48rem;
  margin-top: 0.53rem;
}
.erweima img {
  width: 3.74rem;
  height: 3.74rem;
  margin-top: 0.33rem;
  background: chartreuse;
}
</style>



// WEBPACK FOOTER //
// src/view/activity/activitydes.vue